<kendo-upload
  [saveUrl]="importUrl"
  (upload)="beginUpload()"
  (complete)="onComplete($event)"
  (success)="onSuccess($event)"
  (error)="onError($event)"
  [autoUpload]="false"
  [batch]="multiple"
  [multiple]="multiple"
  [accept]="acceptedTypes"
></kendo-upload>
